import { render } from "./OrdersManage.vue?vue&type=template&id=2c9ff31b&scoped=true"
import script from "./OrdersManage.vue?vue&type=script&lang=js"
export * from "./OrdersManage.vue?vue&type=script&lang=js"

import "./OrdersManage.vue?vue&type=style&index=0&id=2c9ff31b&lang=css"
import "./OrdersManage.vue?vue&type=style&index=1&id=2c9ff31b&scoped=true&lang=css"
import "./OrdersManage.vue?vue&type=style&index=2&id=2c9ff31b&lang=scss"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9ff31b"]])

export default __exports__